import { memo } from 'react';
import { Typography } from '@tempmee/react';
import { colors } from '@tempmee/tailwind';
import { Box, Pressable } from '~/commonComponents';

interface IFeedbackItemProps {
  label: string;
  isSelected: boolean;
  onClick: () => void;
}

const FeedbackItemComponent = ({ label, isSelected, onClick }: IFeedbackItemProps) => (
  <Pressable key={label} onPress={onClick}>
    <Box
      minWidth={206}
      borderRadius={24}
      backgroundColor={isSelected ? colors.primary[50] : colors.shades[0]}
      border={`1.5px solid ${isSelected ? colors.secondary[500] : colors.neutral[100]}`}
      style={{ cursor: 'pointer' }}
    >
      <Typography as="span" style={{ paddingBlock: 8, paddingInline: 20 }}>
        {label}
      </Typography>
    </Box>
  </Pressable>
);

export const FeedbackItem = memo(FeedbackItemComponent);
